import { CALL_API } from 'redux-api-middleware';

export const REQUEST_GET = Symbol('REQUEST_GET');
export const SUCCESS_GET = Symbol('SUCCESS_GET');
export const FAILURE_GET = Symbol('FAILURE_GET');

export function getUser () {
	return {
		[CALL_API]: {
      		endpoint: `${process.env.API_URI}/api/user`,
			method: 'GET',
			headers: {
				'Accept': 'application/json'
			},
			types: [
				REQUEST_GET,
				SUCCESS_GET,
				FAILURE_GET,
			],
		},
	};
}
